import { SidePanelStructure } from 'components/secondaryMarket/shared/SidePanel/SidePanelStructure';
import { FC } from 'react';

import { ConnectedNotReadySidePanel } from './notReady';
import { ConnectedOrderPlacedSidePanel } from './orderPlaced';
import { PendingOrderSidePanel } from './pending/PlacingSidePanel';
import { ConnectedReadySidePanel } from './ready';
import { ConnectedRejectedOrderSidePanel } from './rejected';
import type { SidePanelProps } from './sidePanel.connect';
import { connectSidePanel } from './sidePanel.connect';

export const DlpOrderSidePanel: FC<SidePanelProps> = ({ tabId, status }) => {
  return (
    <SidePanelStructure>
      {status === 'NOT_READY' && <ConnectedNotReadySidePanel tabId={tabId} className="flex-grow-1 min-h-0" />}
      {status === 'READY' && <ConnectedReadySidePanel tabId={tabId} className="flex-grow-1 min-h-0" />}
      {status === 'ORDER_PENDING' && <PendingOrderSidePanel className="flex-grow-1 min-h-0" />}
      {(status === 'ORDER_PLACED' || status === 'ORDER_STALE') && (
        <ConnectedOrderPlacedSidePanel tabId={tabId} className="flex-grow-1 min-h-0" />
      )}
      {status === 'ORDER_FAILED' && <ConnectedRejectedOrderSidePanel tabId={tabId} className="flex-grow-1 min-h-0" />}
    </SidePanelStructure>
  );
};

DlpOrderSidePanel.displayName = 'DlpOrderSidePanel';

export const ConnectedDlpOrderSidePanel = connectSidePanel(DlpOrderSidePanel);
